export async function copyTextToClipboard(text: string): Promise<void> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
  } catch {
    // Falha pode ocorrer quando rodando dentro de um iframe sem
    // `allow="clipboard-write"`. Cai para o fallback abaixo.
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);

  try {
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    const succeeded = document.execCommand('copy');
    if (!succeeded) {
      throw new Error('Falha ao copiar texto para a área de transferência');
    }
  } finally {
    document.body.removeChild(textarea);
  }
}
